import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpEventType, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../_shared/components/spinner/spinner.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TextModalComponent } from '../_shared/components/modals/text-modal/text-modal.component';
import { GlobalSharedService } from '../_shared/services/global-shared.service';

export const SHOW_SPINNER_HTTP_TOKEN = new HttpContextToken<boolean>(() => true);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private spinnerCount = 0;

  constructor(private authService: AuthService, private spinner: SpinnerService, private modalService: NgbModal, private sharedService: GlobalSharedService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestWithSpinner = request.context.get(SHOW_SPINNER_HTTP_TOKEN);

    if (requestWithSpinner) {
      if (this.spinnerCount === 0) {
        this.spinner.show();
      }

      this.spinnerCount++;
    }

    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this.authService.currentUserValue;

    if (currentUser != null && currentUser.accessToken != null) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.accessToken}`
        }
      });
    }

    return next.handle(request).pipe(
      tap((event) => {
        if (event.type == HttpEventType.Response) {
          if (event.url != null && event.url.includes('/api/')) {
            this.checkNewVersion(event.headers);
          }
        }
      }), finalize(() => {
        if (requestWithSpinner) {
          this.spinnerCount--;

          if (this.spinnerCount === 0) {
            this.spinner.hide();
          }
        }
      }));
  }

  private checkNewVersion(headers: HttpHeaders): void {
    const appId = headers.get('App-ID');

    if (appId != null) {
      if (!this.sharedService.isVersionModalOpen && !this.sharedService.updateVersionLater && this.sharedService.appVersion != null && this.sharedService.appVersion !== appId) {
        this.sharedService.isVersionModalOpen = true;
        const modalRef = this.modalService.open(TextModalComponent);
        modalRef.componentInstance.title = 'COMMON.NEW_VERSION';
        modalRef.componentInstance.body = 'COMMON.NEW_VERSION_INFO';
        modalRef.componentInstance.dismissLabel = 'COMMON.LATER';
        modalRef.componentInstance.closeLabel = 'COMMON.PAGE_REFRESH';
        modalRef.closed.subscribe(_ => window.location.reload());
        modalRef.dismissed.subscribe(_ => this.sharedService.updateVersionLater = true);
      }

      this.sharedService.appVersion = appId;
    }
  }
}
